var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('carousel-page'),(_vm.$homePageInfo.dataSourceType!=='XMHQ')?_c('content-page'):_vm._e(),_c('content-page1'),_c('content-page2'),_c('content-page3'),_c('contact-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }